var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLineArea(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 37,
    viewBox: "0 0 76 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M3.66655 23.155L0.399414 25.2523V36.5H75.7998V0.891586L72.2764 1.92543L68.753 0.684814L65.7421 5.92787L62.475 6.07767L59.2079 7.27608L55.9407 10.7215L52.6736 10.2721L49.4065 14.916L46.1393 16.414L42.8722 15.0658L39.6051 15.9646L36.3379 19.5598L33.0708 18.661L29.8036 21.657L26.5365 22.7056L23.2694 20.7582L20.0022 19.5598L16.7351 20.159L13.468 19.2602L10.2008 23.7542L6.93369 24.3534L3.66655 23.155Z",
    fill: "#1890FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.399414 25.2523L3.66655 23.155L6.93369 24.3534L10.2008 23.7542L13.468 19.2602L16.7351 20.159L20.0022 19.5598L23.2694 20.7582L26.5365 22.7056L29.8036 21.657L33.0708 18.661L36.3379 19.5598L39.6051 15.9646L42.8722 15.0658L46.1393 16.414L49.4065 14.916L52.6736 10.2721L55.9407 10.7215L59.2079 7.27608L62.475 6.07767L65.7421 5.92787L68.753 0.684814L72.2764 1.92543L75.7998 0.891586",
    stroke: "#1890FF",
    strokeWidth: 1.00534,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineArea);
export default __webpack_public_path__ + "static/media/LineArea.e651e7024e284d44d7dc0428454f627d.svg";
export { ForwardRef as ReactComponent };